export const GET_ASSIGNMENT_LIST = 'assignment_list/GET_ASSIGNMENT_LIST'
export const START_LOADING_ASSIGNMENT_LIST = 'assignment_list/START_LOADING_ASSIGNMENT_LIST'
export const STOP_LOADING_ASSIGNMENT_LIST = 'assignment_list/STOP_LOADING_ASSIGNMENT_LIST'
export const INVALIDATE_ASSIGNMENT_LIST = 'assignment_list/INVALIDATE_ASSIGNMENT_LIST'
export const ASSIGNMENT_LIST_LOAD_FAILED = 'assignment_list/ASSIGNMENT_LIST_LOAD_FAILED'
